module.exports = __webpack_public_path__ + "static/media/115.89cee3b7.png";